import Vue from 'vue';

const success = (context, response) => {
  context.rental.image = response.image;
};

const failed = (context, error) => {
  context.showToasterError(error);
  context.loading = false;
};

export default (context, formData) => {
  return Vue.$http.post('/files', formData).then(response => {
    if (response && response.status === 200) {
      success(context, response.data);
    }
  }).catch(error => {
      failed(context, error);
  });
}



// WEBPACK FOOTER //
// ./src/app/services/rental/storeFiles.js